import { ErrorMessages } from "@/constants/error.enum";
import { ToastErrors } from "@/constants/generic-errors.enum";
import { ActionTypes } from "@/store/action-types";
import { MutationTypes } from "@/store/mutation-types";
import { useStore } from '@/store/store';
import router from "@/router"
import { client } from "@/api/client-v2";

// Track active toast timeouts to clear them when needed
let activeToastTimeouts: number[] = [];

export function showToast(error?: string) {
    let err = error;
    if (!error) {
        err = 'si è verificato un errore';
    }
    const store = useStore();
    store.commit(MutationTypes.SET_SHOW_ERROR, err);
    const timeoutId = window.setTimeout(() => {
        store.commit(MutationTypes.SET_SHOW_ERROR, null);
        // Remove this timeout from active list
        activeToastTimeouts = activeToastTimeouts.filter(id => id !== timeoutId);
    }, 3000);
    activeToastTimeouts.push(timeoutId);
}

export function showSuccessToast(error: string) {
    const store = useStore();
    store.commit(MutationTypes.SET_SHOW_SUCCESS, error);
    const timeoutId = window.setTimeout(() => {
        store.commit(MutationTypes.SET_SHOW_SUCCESS, null);
        // Remove this timeout from active list
        activeToastTimeouts = activeToastTimeouts.filter(id => id !== timeoutId);
    }, 3000);
    activeToastTimeouts.push(timeoutId);
}

// Clear all pending toast timeouts
export function clearToastTimeouts() {
    activeToastTimeouts.forEach(clearTimeout);
    activeToastTimeouts = [];
}

//METODO PER FORZARE IL LOGOUT
export function forceLogout() {
    const store = useStore();
    // Clear any pending toast timeouts before navigation to prevent DOM errors
    clearToastTimeouts();
    store.dispatch(ActionTypes.LOGOUT, null);
    store.commit(MutationTypes.RESET_STORE, null);
    store.commit(MutationTypes.SET_FORCED_LOGOUT, true);
    client.logout();
    router.push("login");
}

export function handleError(error: any, _showToast = false) {
    const store = useStore();
    console.error(error);

    store.commit(MutationTypes.CLOSE_LOADER, null);
    if (error.message === ErrorMessages.ERROR_REFRESH_TOKENS) {
        forceLogout();
    }
    else if (_showToast) {
        let message = ToastErrors.GENERIC;
        if (error.response) {
            if (error.response.data) {
                message = error.response.data.message || ToastErrors.GENERIC;
            }
        }
        // Always use generic error message for client-side JavaScript errors
        // to avoid i18n translation issues with technical error messages
        showToast(message);
    }
}